export interface Service {
  id: string;
  icon: string;
  image: string;
  title: string;
  description: string;
  href: string;
  tag?: string;
}

export const services: Service[] = [
  {
    id: "quality-vehicles",
    icon: "ri-car-line",
    image: "https://public.readdy.ai/ai/img_res/c0a32a530b2b10eb1df3d7c8a813492d.jpg",
    title: "Quality Pre-Owned Vehicles",
    description:
      "Explore our hand-selected inventory of premium pre-owned SUVs, sedans, and trucks. Every vehicle meets our rigorous quality standards before reaching the lot.",
    href: "https://www.uagmn.com/inventory/",
    tag: "37+ SUVs Available",
  },
  {
    id: "financing",
    icon: "ri-bank-card-line",
    image: "https://readdy.ai/api/search-image?query=professional%20man%20and%20woman%20signing%20car%20purchase%20paperwork%20at%20modern%20dealership%20desk%20car%20keys%20on%20table%20warm%20interior%20lighting%20luxury%20office%20setting%20clean%20elegant%20upscale%20professional%20atmosphere&width=800&height=500&seq=uag-svc-fin-v5&orientation=landscape",
    title: "Flexible Auto Financing",
    description:
      "We work with multiple trusted lenders to secure your financing regardless of credit history. Good credit, bad credit, or first-time buyer — we find a solution.",
    href: "https://www.uagmn.com/apply-online/",
    tag: "All Credit Scores Welcome",
  },
  {
    id: "warranty",
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20car%20dealership%20interior%20showroom%20polished%20concrete%20floor%20gleaming%20premium%20vehicle%20spotlit%20dramatic%20overhead%20lighting%20dark%20background%20elegant%20quality%20trust%20premium%20automotive%20brand%20experience&width=800&height=500&seq=uag-svc-war-v5&orientation=landscape",
    title: "15-Day Warranty Protection",
    description:
      "Every purchase is backed by our 15-day warranty guarantee. Drive off the lot with full confidence and the peace of mind you deserve.",
    href: "https://www.uagmn.com/warranty/",
    tag: "Included with Every Purchase",
  },
  {
    id: "test-drive",
    icon: "ri-steering-2-line",
    image: "https://readdy.ai/api/search-image?query=driver%20hand%20on%20steering%20wheel%20inside%20premium%20luxury%20vehicle%20driving%20scenic%20countryside%20road%20golden%20sunset%20light%20bokeh%20background%20freedom%20driving%20experience%20aspirational%20automotive%20lifestyle%20photography&width=800&height=500&seq=uag-svc-td-v5&orientation=landscape",
    title: "Personalized Test Drive",
    description:
      "Experience your potential vehicle firsthand. Schedule a test drive with our expert consultants who help you find the right fit for your lifestyle and budget.",
    href: "https://www.uagmn.com/schedule-a-test-drive/",
    tag: "No Pressure, No Rush",
  },
  {
    id: "pre-qualified",
    icon: "ri-file-check-line",
    image: "https://readdy.ai/api/search-image?query=person%20using%20smartphone%20showing%20approved%20notification%20modern%20clean%20interior%20background%20car%20keys%20visible%20on%20desk%20premium%20lifestyle%20photography%20warm%20light%20minimal%20upscale%20setting&width=800&height=500&seq=uag-svc-pq-v5&orientation=landscape",
    title: "Get Pre-Qualified Today",
    description:
      "Know your buying power before you shop. Complete our quick, no-obligation online pre-qualification in minutes and shop with confidence.",
    href: "https://www.uagmn.com/get-pre-qualified/",
    tag: "Quick & No Obligation",
  },
  {
    id: "car-finder",
    icon: "ri-search-eye-line",
    image: "https://readdy.ai/api/search-image?query=friendly%20salesperson%20showing%20vehicle%20selection%20on%20tablet%20to%20happy%20couple%20in%20modern%20bright%20dealership%20showroom%20warm%20lighting%20premium%20automotive%20interior%20professional%20helpful%20service%20upscale%20experience&width=800&height=500&seq=uag-svc-cf-v5&orientation=landscape",
    title: "Car Finder Service",
    description:
      "Tell us what you need and we will find it. Our car finder service matches you with the perfect vehicle based on your exact requirements and budget.",
    href: "https://www.uagmn.com/car-finder/",
    tag: "Custom Search for You",
  },
];

export const bodyTypes = [
  {
    name: "SUV",
    count: "37 Vehicles",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/suv.webp",
    href: "https://www.uagmn.com/inventory/?body_type=SUV",
  },
  {
    name: "Sedan",
    count: "19 Vehicles",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/sedan.webp",
    href: "https://www.uagmn.com/inventory/?body_type=SEDAN",
  },
  {
    name: "Pickup",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/pickup.webp",
    href: "https://www.uagmn.com/inventory/?body_type=PICKUP",
  },
  {
    name: "Coupe",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/coupe.webp",
    href: "https://www.uagmn.com/inventory/?body_type=COUPE",
  },
  {
    name: "Hatchback",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/hatchback.webp",
    href: "https://www.uagmn.com/inventory/?body_type=HATCHBACK",
  },
  {
    name: "Convertible",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/convertible.webp",
    href: "https://www.uagmn.com/inventory/?body_type=CONVERTIBLE",
  },
  {
    name: "Van",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/van.webp",
    href: "https://www.uagmn.com/inventory/?body_type=VAN",
  },
  {
    name: "Wagon",
    count: "1 Vehicle",
    image: "https://www.uagmn.com/dealercenter/img/body-type-images/wagon.webp",
    href: "https://www.uagmn.com/inventory/?body_type=WAGON",
  },
];
